<template>
  <div class="success-page">
    <div v-if="advanced">
      <div style="text-align: center">
        <embed :src="submitIcon" style="width:120px;">
      </div>
      <p class="mt-5">您的报名我们已收到。</p>
      <p>后续将有普华永道的同事与您沟通联系开班事宜， 请注意查收电话与邮箱。</p>
    </div>
    <div v-else>
      <div v-if="data.Thanks && data.Thanks.length > 0">
        <div style="text-align: center">
          <embed :src="submitIcon" style="width:120px;">
        </div>
        <div v-for="(item,index) in data.Thanks" :key="index + '3232'">
          <h3 v-if="item.type === 'text'" class="mt-4 mb-3">
            {{ item.meta.defaultValue }}
          </h3>
          <div v-if="item.type === 'image'" class="mb-3" style="text-align:center">
            <img :style="{'width': item.meta.width, 'height': 'auto'}" :src="item.meta.defaultValue">
          </div>
          <div v-if="item.type === 'section'" class="mb-3" :class="{'mt-5' : item.meta.defaultValue.includes('注') }">
            <div v-if="!item.meta.defaultValue.includes('\n')">{{ item.meta.defaultValue }}</div>
            <div v-else style="text-align:left">
              <div v-for="(it, ind) in item.meta.defaultValue.split('\n')" :key="ind">
                <div v-if="it.includes('||')">
                  <div v-for="(i, ix) in it.split('||')" :key="ix">
                    <p :class="{'suojin': ix === 1}">{{ i }}</p>
                  </div>
                </div>
                <p v-else>{{ it }}</p>
              </div>
            </div>
          </div>
        </div>
        <p v-for="(item,index) in attachment" :key="index" class="mb-3">
          <a :href="item" class="v-ellipsis btn-link" type="primary" size="mini" plain>{{ item | fileDefaultValue }}
          </a>
        </p>
      </div>
      <div v-else style="text-align: center">
        <embed :src="submitIcon" style="width:120px;">
        <h3>感谢参与</h3>
      </div>
    </div>
  </div>
</template>

<script>
import submitIcon from '@/assets/submit.svg'
import { getSurveyRedirectUrl, removeSurveyRedirectUrl } from '@/util/auth'
export default {
  filters: {
    fileDefaultValue(val) {
      let name = ''
      if (val) {
        const nameArr = val.split('/')
        name = nameArr[nameArr.length - 1]
      }
      return name
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    attachment: {
      type: Array,
      default: () => []
    },
    advanced: {
      type: Boolean,
      default: false
    },
    applyStatus:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      submitIcon,
      backUrl: getSurveyRedirectUrl() || ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.backUrl) {
        removeSurveyRedirectUrl()
        setTimeout(() => {
          this.$router.replace({ path: this.backUrl, query: { back: 'survey', applyStatus: this.applyStatus ? this.applyStatus : ''}})
        }, 200)
      }
    })
  }
}
</script>

<style>
.success-page {
  font-size: 14px;
}

.success-page img {
  max-width: 100%;
}
.suojin {
  text-indent: 3em;
}
</style>
